import { render, staticRenderFns } from "./ggk.vue?vue&type=template&id=49454f67&scoped=true"
import script from "./ggk.vue?vue&type=script&lang=js"
export * from "./ggk.vue?vue&type=script&lang=js"
import style0 from "./ggk.vue?vue&type=style&index=0&id=49454f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49454f67",
  null
  
)

export default component.exports